import { createSvgComponent } from "../../icon/createSvgComponent";
import TestTube from "@core/__generated__/icon/figma/test-tube.svg";
export default createSvgComponent(TestTube);